import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import useFlowFeed from '../../../../hooks/useFlowFeed';
import { useGetFlowResponseQuery } from '../../../../queries/Feed';
import routesList from '../../../../routesList';
import { useUpdateSingleFlowReactionMutation } from '../../../../queries/Flows/Feed';
import { FLOWS } from '../../../../constants/routes';
import useHistoryWrapper from '../../../../hooks/useHistoryWrapper';
import useReactionUpdatedSocket from '../../../../hooks/useReactionUpdatedSocket';
import { PageType } from '../../../../hooks/useReactionUpdatedSocket/types';

export const useNewSingleFlowFeedPostController = () => {
  const { search } = useLocation();
  const flowId = new URLSearchParams(search).get('flowId') || '';
  const responseId = new URLSearchParams(search).get('responseId') || '';
  const history = useHistoryWrapper();

  const { mutate: mutateFlowPostReaction } =
    useUpdateSingleFlowReactionMutation(flowId);

  useReactionUpdatedSocket({ pageType: PageType.SingleFlowFeed });

  const onPostDelete = useCallback(() => {
    history.push(routesList.HOME);
  }, [history]);

  const { feedContextProps, isProfileInfoLoading, profileData } = useFlowFeed({
    onPostDelete,
    mutateResponseReaction: mutateFlowPostReaction,
  });

  const {
    isLoading: isSingleFlowFeedPostLoading,
    isError,
    data,
  } = useGetFlowResponseQuery(flowId, responseId);

  const isLoading = isSingleFlowFeedPostLoading || isProfileInfoLoading;

  const handleEditPostClick = useCallback(
    (flow: { postId: string }) => {
      const editResponseUrl = `${FLOWS}/${flowId}/edit/${flow.postId}`;
      history.push(editResponseUrl);
    },
    [flowId, history],
  );

  return {
    isError,
    isLoading,
    profileData,
    data,
    feedContextProps,
    handleEditPostClick,
  };
};
